module.exports = __webpack_public_path__ + "img/200.3656fbc4.jpg";